import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SideMenu from './../../Components/SideMenu';
import WithSidemenuHeader from './../../Components/WithSidemenuHeader';
import React, { useEffect, useState } from 'react'
import { faClone, faTrashCan, faEye, faDownload, faUsers, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons';
import './Outbound.css'
import Pager from './../../Helper/Pager';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useForm, Controller } from "react-hook-form";
import { PaginationProps } from '@/Models/PeoplesModel';
import { NotificationModel } from './../../Models/SecurityModel';
import Avatar from './../../Components/Avatar';
import { confirmationManager } from './../../Components/ConfirmationDialog/ConfirmationManager';
import CheckMark from './../../Components/CheckMark';
import { useDispatch, useSelector } from 'react-redux';
import OutboundService from './../../ApiServices/Outbound.Service';
import QuestionnaireTemplatesService from './../../ApiServices/QuestionnaireTemplates.Service';
import { useNavigate } from 'react-router-dom';
import {  S3UploadQuestionnaire_Enterpriseapps,S3DownloadForEnterpriseQuestionnaire } from '../../ApiServices/S3Bucket';
import CollaboratorPopup from './CollaboratorPopup';
import { getClientDetails } from '../../ApiServices/SettingsApi';


interface OutboundFormModel {
    clientName: string;
    email: string;
    status: boolean;
    file?: File;
    selectedTemplate?: string;
}

interface OutboundModel {
    _id: string;
    clientName: string;
    email: string;
    status: boolean;
    createdAt: string;
    fileName: string;
    collaborators?: string[];
    file: {
        questions: {
            question: string;
            answer: string;
        }[];
    };
}

const Outbound = () => {
    const [show, setShow] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [succssMsg, setSuccssMsg] = useState<string>('')
    const [inviteMsg, setInviteMsg] = useState<string>('');
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [outboundList, setOutboundList] = useState<OutboundModel[]>([]);
    const [pagination, setPagination] = useState<PaginationProps>({ pageSize: 10, totalPages: 0, currentPage: 1 });
    const [notification, setNotification] = useState<NotificationModel>({ type: 'none', msg: '' });
    const [showCollaboratorPopup, setShowCollaboratorPopup] = useState(false);
    const [selectedOutbound, setSelectedOutbound] = useState<OutboundModel | null>(null);
    const [templates, setTemplates] = useState<any[]>([]);
    const [selectedTemplate, setSelectedTemplate] = useState<string>('');
    const [showTemplateModal, setShowTemplateModal] = useState(false);
    const [templateFormData, setTemplateFormData] = useState({});
    const [templateFile, setTemplateFile] = useState<File | null>(null);
    const [isTemplateLoading, setIsTemplateLoading] = useState(false);
    const clientDetails = useSelector((state: any) => state.AppReducer.clientDetails);
    const dispatch = useDispatch();
    const [localClientDetails, setLocalClientDetails] = useState<any>(null);

    const fetchClientDetails = async () => {
        try {
            console.log('Fetching client details...');
            const result = await getClientDetails();
            console.log('Client details result:', result);
            if (result && result.status === true && result.data && result.data.length > 0) {
                const clientData = result.data[0]; // Get the first client details
                console.log('Client data:', clientData);
                setLocalClientDetails(clientData);
            }
        } catch (error) {
            console.error('Error fetching client details:', error);
        }
    };

    const { control, handleSubmit, formState: { errors }, watch, reset, setValue } = useForm<OutboundFormModel>({
        defaultValues: {
            email: '',
            clientName: '',
            status: true,
            selectedTemplate: ''
        }
    });
    const navigate = useNavigate();

    useEffect(() => {
        fetchClientDetails();
        _getOutboundList();
        fetchTemplates();
    }, []);

    const handleClose = () => {
        setShow(false);
        setSelectedFile(null);
        setSelectedTemplate('');
    };

    const handleShow = () => {
        setNotification({ type: 'none', msg: '' });
        reset({ email: '', clientName: '', status: true, selectedTemplate: ''})
        setSelectedFile(null);
        setSelectedTemplate('');
        setShow(true)
    };

    const onFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setSelectedFile(file);
            setValue('file', file);
            setSelectedTemplate('');
            setValue('selectedTemplate', '');
        }
    };

    useEffect(() => {
        _getOutboundList();
        fetchTemplates();
    }, [pagination.currentPage]);

    const _getOutboundList = async () => {
        const result: any = await OutboundService.getOutboundList(pagination.currentPage, pagination.pageSize);
        if (result && result.status === true) {
            setOutboundList(result.data);
            setPagination((preProps: any) => ({ ...preProps, totalPages: result?.totalPages }));
        } else {
            setOutboundList([]);
            setNotification({ type: 'error', msg: result.message || 'Error fetching outbound list' });
        }
    }

    const fetchTemplates = async () => {
        try {
            const result = await QuestionnaireTemplatesService.getAllTemplates();
            if (result && result.status === true) {
                setTemplates(result.data);
            } else {
                setTemplates([]);
            }
        } catch (error) {
            console.error('Error fetching templates:', error);
            setTemplates([]);
        }
    };

    const onSubmit = async (data: OutboundFormModel) => {
        setNotification({ type: 'none', msg: '' });
        setLoading(true);

        try {
            let fileToUse = selectedFile;
            let fileName = selectedFile?.name || '';

            // If template is selected, get the template file
            if (data.selectedTemplate && !selectedFile) {
                try {
                    const templateResult = await QuestionnaireTemplatesService.getTemplateQuestions(data.selectedTemplate);
                    if (templateResult && templateResult.status === true) {
                        // Create a file from template data
                        const template = templateResult.data.template;
                        const questions = templateResult.data.questions;
                        
                        console.log('Full template object:', template);
                        console.log('Template file property:', template.file);
                        console.log('Template file keys:', Object.keys(template.file || {}));
                        
                        // For now, we'll use the template name as filename
                        fileName = template.fileName;
                        
                        // We need to create a file from the template buffer
                        console.log('Template file buffer:', template.file);
                        console.log('Template file buffer type:', typeof template.file);
                        console.log('Template file buffer length:', template.file.length);
                        console.log('Template file buffer data:', template.file.data);
                        
                        // Handle different buffer formats
                        let bufferData;
                        if (template.file.data) {
                            // If it's a MongoDB Buffer with data property
                            bufferData = template.file.data;
                        } else if (template.file instanceof ArrayBuffer) {
                            // If it's already an ArrayBuffer
                            bufferData = template.file;
                        } else if (template.file.buffer) {
                            // If it's a Buffer with buffer property
                            bufferData = template.file.buffer;
                        } else {
                            // Try to use it directly
                            bufferData = template.file;
                        }
                        
                        console.log('Buffer data to use:', bufferData);
                        console.log('Buffer data type:', typeof bufferData);
                        console.log('Buffer data length:', bufferData?.length);
                        
                        // Convert to Uint8Array for Blob
                        const uint8Array = new Uint8Array(bufferData);
                        console.log('Uint8Array length:', uint8Array.length);
                        
                        const blob = new Blob([uint8Array], { type: template.mimeType });
                        console.log('Blob size:', blob.size);
                        
                        fileToUse = new File([blob], template.fileName, { type: template.mimeType });
                        console.log('File size:', fileToUse.size);
                        
                        console.log('Template file created:', fileToUse);
                        console.log('Template questions:', questions);
                    } else {
                        setNotification({ type: 'error', msg: 'Error loading template' });
                        setLoading(false);
                        return;
                    }
                } catch (error) {
                    console.error('Error loading template:', error);
                    setNotification({ type: 'error', msg: 'Error loading template' });
                    setLoading(false);
                    return;
                }
            }

            if (!fileToUse) {
                setNotification({ type: 'error', msg: 'Please upload a file or select a template' });
                setLoading(false);
                return;
            }

            console.log('fileToUse:', fileToUse);
            console.log('fileToUse type:', typeof fileToUse);
            console.log('fileToUse instanceof File:', fileToUse instanceof File);
            console.log('data:', data);

            const formData = new FormData();
            formData.append('clientName', data.clientName);
            formData.append('email', data.email);
            formData.append('files', fileToUse);
            formData.append('fileName', fileName);
            
            // Debug FormData contents
            console.log("FormData contents:");
            formData.forEach((value, key) => {
                console.log(`${key}:`, value);
                if (value instanceof File) {
                    console.log(`  - File name: ${value.name}`);
                    console.log(`  - File size: ${value.size}`);
                    console.log(`  - File type: ${value.type}`);
                }
            });

            const result: any = await OutboundService.saveOutbound(formData);
            console.log(result, 'result');
            if (result && result.status === true) {


                // Use local client details if available, otherwise fall back to Redux state
                const effectiveClientDetails = localClientDetails || clientDetails;
                
                console.log('S3 Upload parameters:');
                console.log('  - file:', fileToUse);
                console.log('  - fileId:', result?.data?.outboundId);
                console.log('  - bucketName:', effectiveClientDetails?.questionnairesBucket);
                console.log('  - folderName:', "outboundFolder");
                console.log('  - effectiveClientDetails:', effectiveClientDetails);
                console.log('  - localClientDetails:', localClientDetails);
                console.log('  - reduxClientDetails:', clientDetails);
                
                // Check if we have the required bucket name
                if (!effectiveClientDetails?.questionnairesBucket) {
                    console.error('Missing questionnairesBucket in effectiveClientDetails:', effectiveClientDetails);
                    console.log('Attempting to fetch client details manually...');
                    await fetchClientDetails();
                    
                    // Check again after fetching
                    if (!localClientDetails?.questionnairesBucket) {
                        setNotification({ type: 'error', msg: 'Missing bucket configuration. Please refresh the page.' });
                        setLoading(false);
                        return;
                    }
                }
                
                S3UploadQuestionnaire_Enterpriseapps({ 
                    file: fileToUse, 
                    fileId: result?.data?.outboundId, 
                    bucketName: effectiveClientDetails.questionnairesBucket, 
                    folderName: "outboundFolder" 
                }).then((res: any) => {
                    console.log(res, 'res file');
                    
                }).catch((err: any) => {
                    console.log(err, 'err file');
                })

                handleInviteMsg();
                setNotification({ type: 'success', msg: 'Outbound sent successfully' });
                reset({ email: '', clientName: '', status: true})
                setSelectedFile(null);
                _getOutboundList();
                setTimeout(() => {
                    handleClose();
                }, 4000);
            } else {
                setNotification({ type: 'error', msg: result.message || 'Error sending outbound' });
            }
            setLoading(false);
        } catch (error) {
            setNotification({ type: 'error', msg: 'An error occurred' });
            setLoading(false);
        }
    }

    const handleInviteMsg = () => {
        setSuccssMsg('Outbound sent successfully!');
        setTimeout(() => {
            setInviteMsg('');
            setSuccssMsg('');
        }, 4000);
    }

    const handlePageChange = (page: number) => {
        setPagination((preProps: any) => ({ ...preProps, currentPage: page }));
    };

    const handleReview = (item: OutboundModel) => {
        navigate(`/outbound/review/${item._id}`);
    };

    const handleDelete = async (item: OutboundModel) => {
        confirmationManager.requestConfirmation({
            heading: 'Delete Outbound',
            message: `Are you sure you want to delete the outbound for ${item.clientName}?`,
            onConfirm: async () => {
                try {
                    const result = await OutboundService.deleteOutbound(item._id);
                    if (result && result.status === true) {
                        setNotification({ type: 'success', msg: 'Outbound deleted successfully' });
                        _getOutboundList(); // Refresh the list
                    } else {
                        setNotification({ type: 'error', msg: result.message || 'Error deleting outbound' });
                    }
                } catch (error) {
                    setNotification({ type: 'error', msg: 'An error occurred while deleting' });
                }
            }
        });
    };

    const handleDownload = async (item: OutboundModel) => {
        try {
            // Use local client details if available, otherwise fall back to Redux state
            const effectiveClientDetails = localClientDetails || clientDetails;
            
            console.log('Download parameters:');
            console.log('  - item:', item);
            console.log('  - effectiveClientDetails:', effectiveClientDetails);
            console.log('  - questions:', item.file?.questions);

            const downloadObj = {
                questions: item.file?.questions || [],
                fileAndFolder: 'outboundFolder',
                bucketName: effectiveClientDetails?.questionnairesBucket,
                fileId: item._id, // Use fileName as fileId
                fileName: item.fileName
            };

            console.log('Download object:', downloadObj);

            // Validate required fields
            if (!downloadObj.bucketName) {
                setNotification({ type: 'error', msg: 'Missing bucket configuration for download' });
                return;
            }

            if (!downloadObj.questions || downloadObj.questions.length === 0) {
                setNotification({ type: 'error', msg: 'No questions found for download' });
                return;
            }

            try {
                const res = await S3DownloadForEnterpriseQuestionnaire({ obj: downloadObj });
                console.log(res, 'res');
                // Optionally log this event
                // createDownloadLogs([downloadObj.fileName], 'enterprise-apps', 'editor', true);
            } catch (err) {
                console.error(err, 'err file');
                setNotification({ type: 'error', msg: 'Failed to download file' });
            }

        } catch (error) {
            console.error('Download error:', error);
            setNotification({ type: 'error', msg: 'An error occurred while downloading' });
        }
    };

    const handleCollaboratorClick = (item: OutboundModel) => {
        setSelectedOutbound(item);
        setShowCollaboratorPopup(true);
    };

    const handleCollaboratorClose = () => {
        setShowCollaboratorPopup(false);
        setSelectedOutbound(null);
        // Refresh the outbound list to update collaborator counts
        _getOutboundList();
    };

    const formatFileSize = (bytes: number) => {
        if (bytes === 0) return '0 Bytes';
        const k = 1024;
        const sizes = ['Bytes', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
    };

    const handleDeleteTemplate = async (templateId: string) => {
        confirmationManager.requestConfirmation({
            heading: 'Delete Template',
            message: 'Are you sure you want to delete this template?',
            onConfirm: async () => {
                try {
                    const result = await QuestionnaireTemplatesService.deleteTemplate(templateId);
                    if (result && result.status === true) {
                        setNotification({ type: 'success', msg: 'Template deleted successfully' });
                        fetchTemplates();
                    } else {
                        setNotification({ type: 'error', msg: result.message || 'Error deleting template' });
                    }
                } catch (error) {
                    setNotification({ type: 'error', msg: 'An error occurred while deleting template' });
                }
            }
        });
    };

    const handleDownloadTemplate = async (template: any) => {
        try {
            console.log('Downloading template:', template);
            
            // Create a blob from the template buffer
            const uint8Array = new Uint8Array(template.file.data || template.file);
            const blob = new Blob([uint8Array], { type: template.mimeType });
            
            // Create download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = template.fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            
            setNotification({ type: 'success', msg: 'Template downloaded successfully' });
        } catch (error) {
            console.error('Error downloading template:', error);
            setNotification({ type: 'error', msg: 'Failed to download template' });
        }
    };

    const handleTemplateFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
            setTemplateFile(file);
        }
    };

    const handleTemplateSubmit = async () => {
        if (!templateFile) {
            setNotification({ type: 'error', msg: 'Please upload a file' });
            return;
        }

        setIsTemplateLoading(true);
        try {
            const formData = new FormData();
            formData.append('file', templateFile);

            const result = await QuestionnaireTemplatesService.createTemplate(formData);
            if (result && result.status === true) {
                setNotification({ type: 'success', msg: 'Template created successfully' });
                setShowTemplateModal(false);
                setTemplateFormData({});
                setTemplateFile(null);
                fetchTemplates();
            } else {
                setNotification({ type: 'error', msg: result.message || 'Error creating template' });
            }
        } catch (error) {
            setNotification({ type: 'error', msg: 'An error occurred while creating template' });
        } finally {
            setIsTemplateLoading(false);
        }
    };



    return (
        <main className="acc-main">
            <section className="left-menu-col">
                <SideMenu />
            </section>
            <section className="right-routers-col">
                <WithSidemenuHeader title={'Security Questionnaire'} />
                <div className="router-container ">
                    <div className="row">
                        <div className="col-lg-10 col-xl-10 offset-xl-1 offset-lg-1 mt-4">
                            {/* Template Management Section */}
                            <div className="card border mb-4">
                                <div className="card-header bg-light border-bottom d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0" style={{ fontWeight: '600', color: 'var(--lt-light-blue)' }}>Questionnaire Templates</h6>
                                    <button onClick={() => setShowTemplateModal(true)} className="btn btn-sm btn-primary">
                                        <FontAwesomeIcon icon={faPlus} className="me-1" />
                                        Add Template
                                    </button>
                                </div>
                                <div className="card-body px-0 pt-1">
                                    {templates.length > 0 ? (
                                        <>
                                            {templates.map((template) => (
                                                <div key={template._id} className="people-sec">
                                                    <div className="row">
                                                        <div className="col-md-8 col-8">
                                                            <div className='d-flex'>
                                                                <div className='d-flex'>
                                                                    <span>
                                                                        <div className="people-name">{template.fileName}</div>
                                                                        <p className='people-desc'>
                                                                            {formatFileSize(template.fileSize)} • {new Date(template.createdAt).toLocaleDateString()}
                                                                        </p>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-4 col-12">
                                                            <div className="d-flex justify-content-end mt-2">
                                                                <button 
                                                                    onClick={() => handleDownloadTemplate(template)}
                                                                    className='btn btn-sm btn-outline-primary border me-2'
                                                                    title="Download Template"
                                                                >
                                                                    <FontAwesomeIcon icon={faDownload} />
                                                                </button>
                                                                <button 
                                                                    onClick={() => handleDeleteTemplate(template._id)}
                                                                    className='btn btn-sm btn-outline-danger border px-2'
                                                                    title="Delete Template"
                                                                >
                                                                    <FontAwesomeIcon icon={faTrash} />
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </>
                                    ) : (
                                        <div className="text-center py-3">
                                            <p className="text-muted mb-0">No templates available</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <div className="card border">
                                <div className="card-header bg-light border-bottom">
                                    <button onClick={handleShow} className="btn btn-sm btn-success ms-auto d-flex" >New Questionnaire</button>
                                </div>
                                <div className="card-body px-0 pt-1">
                                    {outboundList && outboundList.length ? <>
                                        {outboundList.map((item: OutboundModel, index: number) => (
                                        <div className="people-sec">
                                            <div key={`index-${index}`} className="row  ">
                                                <div className="col-md-5 col-8">
                                                    <div className='d-flex'>
                                                        <div>
                                                            <input className="form-check-input mt-1 me-3 d-none" type="checkbox" value="" aria-label="Checkbox for following text input" />
                                                        </div>

                                                        <div className='d-flex'>
                                                            <span>
                                                                <Avatar key={index} username={item.clientName} />
                                                            </span>
                                                            <span>
                                                                <div className="people-name">{item.clientName}</div>
                                                                <p className='people-desc'>{new Date(item.createdAt).toLocaleDateString()}</p>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-3 col-12 pe-0 email-sec">
                                                    {item.email}
                                                    {item.collaborators && item.collaborators.length > 0 && (
                                                        <div className="collaborators-info mt-1">
                                                            <small className="text-muted">
                                                                <FontAwesomeIcon icon={faUsers} className="me-1" />
                                                                {item.collaborators.length} collaborator{item.collaborators.length > 1 ? 's' : ''}
                                                            </small>
                                                        </div>
                                                    )}
                                                </div>

                                                <div className="col-md-2 col-12 pe-0">
                                                    <div className='ms-auto PendingInvite'>{item.status ? "Complete" : "Pending"} </div>
                                                </div>
                                                <div className="col-md-2 col-12">
                                                    <div className="d-flex justify-content-end mt-2">
                                                        <button 
                                                            onClick={() => handleCollaboratorClick(item)}
                                                            className='btn btn-sm btn-outline-info border me-2'
                                                            title="Manage Collaborators"
                                                        >
                                                            Collaborators
                                                        </button>
                                                        <button 
                                                            onClick={() => handleReview(item)}
                                                            className='btn btn-sm btn-success me-2'
                                                        >
                                                            Review
                                                        </button>
                                                        <button 
                                                            onClick={() => handleDownload(item)}
                                                            className='btn btn-sm btn-outline-primary border me-2'
                                                        >
                                                            <FontAwesomeIcon icon={faDownload} />
                                                        </button>
                                                        <button 
                                                            onClick={() => handleDelete(item)}
                                                            className='btn btn-sm btn-outline-danger border px-2'
                                                        >
                                                            <FontAwesomeIcon icon={faTrashCan} />
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}</> : <></>}
                                    
                                    <div className="d-flex justify-content-end mt-3 pe-3">
                                        <Pager
                                            totalPages={pagination.totalPages}
                                            currentPage={pagination.currentPage}
                                            onPageChange={handlePageChange}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Modal size="lg" centered show={show} onHide={handleClose} animation={true}>
                <form autoComplete={'off'} onSubmit={handleSubmit(onSubmit)}>
                    <Modal.Header closeButton className='bg-light'>
                        <Modal.Title className='fs-5'>Send Security Questionnaire</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className='mt-4 px-lg-5'>
                        <div className="row">
                            <div className="col-md-6 offset-md-3">
                                <div className="upload-section mb-4">
                                    <label htmlFor="outbound-file" style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                                        <div className="icon-container">
                                            <img src={process.env.PUBLIC_URL + '/assets/imgs/upload-icon.png'} alt="upload-icon" style={{ width: 64, marginBottom: '12px' }} />
                                        </div>
                                        <div className="upload-text-container">
                                            <p style={{ overflow: 'hidden', margin: 0 }}>
                                                {selectedFile ? selectedFile.name : 'Upload File'}
                                            </p>
                                        </div>
                                        <input 
                                            id="outbound-file" 
                                            type="file" 
                                            accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                                            onChange={onFileUpload} 
                                            style={{ display: 'none' }} 
                                        />
                                    </label>
                                </div>
                                <Controller
                                    name="clientName"
                                    control={control}
                                    rules={{
                                        required: 'Client name is required'
                                    }}
                                    render={({ field }) => <input type="text" autoComplete="off" className="form-control py-2 mb-3" placeholder="Client Name" {...field} />}
                                />
                                {errors.clientName && (
                                    <div className="sc-input-err-msg" style={{marginTop:-15}}>{errors.clientName?.message}</div>
                                )}
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        required: 'This field is required',
                                        pattern: {
                                            value: /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
                                            message: "Invalid email address"
                                        }
                                    }}
                                    render={({ field }) => <input type="text" autoComplete="off" className="form-control py-2 mb-3" placeholder="Email" {...field} />}
                                />
                                {errors.email && (
                                    <div className="sc-input-err-msg" style={{marginTop:-15}}>{errors.email?.message}</div>
                                )}
                                {!errors.email && notification.type == 'error' && (
                                    <div className="sc-input-err-msg" style={{marginTop:-15}}>{notification?.msg}</div>
                                )}

                                <div className="template-selection mb-3">
                                    <label className="form-label fw-semibold mb-2">Or Select a Template</label>
                                    <Controller
                                        name="selectedTemplate"
                                        control={control}
                                        render={({ field }) => (
                                            <select 
                                                className="form-control py-2" 
                                                {...field}
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                    setSelectedTemplate(e.target.value);
                                                    if (e.target.value) {
                                                        setSelectedFile(null);
                                                    }
                                                }}
                                            >
                                                <option value="">Choose a template...</option>
                                                {templates.map((template) => (
                                                    <option key={template._id} value={template._id}>
                                                        {template.fileName}
                                                    </option>
                                                ))}
                                            </select>
                                        )}
                                    />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className='border-top-0 pb-0'>
                        <Button type='submit' disabled={isLoading} className='custom-btn mx-auto mb-3'>Send Security Questionnaire</Button>
                    </Modal.Footer>
                    <div className='text-center mb-3 d-flex justify-content-center gap-2'>
                        <span>{succssMsg}</span> {succssMsg ? <CheckMark height={20} width={20} color={'success'} /> : null}
                    </div>
                </form>
            </Modal>

            <CollaboratorPopup
                show={showCollaboratorPopup}
                onHide={handleCollaboratorClose}
                outboundId={selectedOutbound?._id || ''}
                clientName={selectedOutbound?.clientName || ''}
            />

            {/* Template Modal */}
            <Modal size="lg" centered show={showTemplateModal} onHide={() => setShowTemplateModal(false)} animation={true}>
                <Modal.Header closeButton className="bg-light">
                    <Modal.Title className="fs-5">Add Template</Modal.Title>
                </Modal.Header>
                <Modal.Body className="mt-4 px-lg-5">
                    <div className="row">
                        <div className="col-md-8 offset-md-2">
                            <div className="upload-section mb-4">
                                <label htmlFor="template-file" style={{ cursor: 'pointer', display: 'block', textAlign: 'center' }}>
                                    <div className="icon-container">
                                        <img 
                                            src={process.env.PUBLIC_URL + '/assets/imgs/upload-icon.png'} 
                                            alt="upload-icon" 
                                            style={{ width: 64, marginBottom: '12px' }} 
                                        />
                                    </div>
                                    <div className="upload-text-container">
                                        <p style={{ overflow: 'hidden', margin: 0 }}>
                                            {templateFile ? templateFile.name : 'Upload Template File'}
                                        </p>
                                    </div>
                                    <input 
                                        id="template-file" 
                                        type="file" 
                                        accept="application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" 
                                        onChange={handleTemplateFileUpload} 
                                        style={{ display: 'none' }} 
                                    />
                                </label>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top">
                    <Button variant="secondary" onClick={() => setShowTemplateModal(false)}>
                        Cancel
                    </Button>
                    <Button 
                        variant="primary" 
                        onClick={handleTemplateSubmit}
                        disabled={isTemplateLoading || !templateFile}
                    >
                        {isTemplateLoading ? 'Creating...' : 'Create Template'}
                    </Button>
                </Modal.Footer>
            </Modal>
        </main>
    )
}

export default Outbound; 